import React from 'react';
import clsx from 'clsx';
import { ChatMarkdown } from '../../common';
import { ReactComponent as BulbIcon } from '../../../assets/onboarding/bulb_icon.svg';
import './DescriptionBox.scss';

type Props = {
  description: string;
  className?: string;
};

const DescriptionBox: React.FC<Props> = ({ description, className }) => {
  if (!description.trim()) {
    return null;
  }

  return (
    <div className={clsx('ai-description-box', className)}>
      <BulbIcon width={12} height={12} className="ai-description-box__bulb" />
      <ChatMarkdown content={description} size="xs" className="ai-description-box__text" />
    </div>
  );
};

export default DescriptionBox;
